// styling
import styles from './styles.module.scss'

// components
import LazyImage from '@components/LazyImage';

// hooks
import {useThemeProvider} from '@contexts/themeContext';

// utils
import {getClubInfo} from '@utils/helpers';
import PropTypes from 'prop-types';
import fallbackLogo from '@assets/clubs/realmadrid.webp';

const PlayerDiscipline = ({player, team, clubID = 'realmadrid', firstName, lastName, red, yellow}) => {
    const club = getClubInfo(clubID) || {};
    const {direction} = useThemeProvider();
    const composedName = [
        player?.first_name ?? player?.firstName ?? firstName,
        player?.last_name ?? player?.lastName ?? lastName,
    ].filter(Boolean).join(' ');
    const playerName = player?.name || composedName || 'No card leader';
    const nameParts = playerName.trim().split(/\s+/);
    const displayFirstName = nameParts.shift();
    const displayLastName = nameParts.join(' ');
    const yellowCards = Number(player?.yellow_card ?? player?.yellowCard ?? yellow ?? 0);
    const redCards = Number(player?.red_card ?? player?.redCard ?? red ?? 0);
    const logo = team?.logo ?? team?.image ?? club.logo ?? fallbackLogo;
    const clubName = team?.team_name ?? team?.name ?? club.name ?? 'Team';

    const drawYellowCards = () => {
        return Array(Math.min(yellowCards, 6)).fill(0).map((_, i) => <span key={i} className={`${styles.card} ${styles.yellow} ${styles[direction]}`}/>)
    }

    return (
        <div className="card h-1 d-flex flex-column g-20">
            <div className="card_header d-flex flex-column g-16 flex-1">
                <LazyImage className="club-logo club-logo--md" src={logo} alt={clubName} />
                <h3>
                    {displayFirstName}
                    {displayLastName && <span className="d-block">{displayLastName}</span>}
                </h3>
            </div>
            <div className="card_footer--sm justify-content-between">
                <div className="d-flex align-items-center g-8">
                    <div className={styles.card_wrapper}>
                        {drawYellowCards()}
                    </div>
                    <span className="label h6">{yellowCards}</span>
                </div>
                <div className="d-flex align-items-center g-8">
                    <span className={`${styles.card} ${styles.red}`}/>
                    <span className="label h6">{redCards}</span>
                </div>
            </div>
        </div>
    )
}

PlayerDiscipline.propTypes = {
    player: PropTypes.object,
    team: PropTypes.object,
    clubID: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    red: PropTypes.number,
    yellow: PropTypes.number
}

export default PlayerDiscipline
